export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const OKTA_CLIENT_ID = import.meta.env.VITE_OKTA_CLIENT_ID;
